import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import type React from "react";
import styled from "styled-components";
import type { ScholarlyArticle } from "../../types/formTypes";
import TextField from "./TextField";

const FieldWrapper = styled.div`
  margin-bottom: 24px;
  text-align: left;
`;

const LabelRow = styled.label`
  display: inline-flex !important;
  flex-direction: row !important;
  align-items: center;
  gap: 4px;
  margin-bottom: 6px;
  font-weight: 700;
  font-size: 16px;
  cursor: text;
  text-align: left;
`;

const RequiredMark = styled.span`
  color: #d32f2f;
`;

const FieldsWrapper = styled.div`
  margin-top: 6px;
  width: 100%;
  box-sizing: border-box;

  input,
  .ant-select {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }
`;

export interface ScholarlyArticleSingleFieldProps {
  label: string;
  name: string;
  value: ScholarlyArticle | undefined;
  onChange: (value: ScholarlyArticle | undefined) => void;
  required?: boolean;
  tooltip?: string;
}

const ScholarlyArticleSingleField: React.FC<
  ScholarlyArticleSingleFieldProps
> = ({ label, name, value, onChange, required = false, tooltip }) => {
  const article = value ?? { identifier: "" };

  const updateField = (updates: Partial<ScholarlyArticle>) => {
    const next = { ...article, ...updates };
    const hasContent = (next.identifier ?? "").trim() !== "";
    onChange(hasContent ? next : undefined);
  };

  return (
    <FieldWrapper>
      <LabelRow htmlFor={name}>
        {label}
        {required && <RequiredMark>*</RequiredMark>}
        {tooltip && (
          <Tooltip title={tooltip}>
            <span style={{ display: "inline-flex", cursor: "help" }}>
              <FontAwesomeIcon
                icon={faCircleInfo}
                style={{
                  color: "var(--color-primary-desat)",
                  fontSize: "0.9rem",
                }}
              />
            </span>
          </Tooltip>
        )}
      </LabelRow>
      <FieldsWrapper>
        <TextField
          label="Identifier"
          name={`${name}-identifier`}
          value={article.identifier ?? ""}
          onChange={(v) => updateField({ identifier: v })}
          tooltip="URL identifier, ideally a DOI for a publication."
        />
      </FieldsWrapper>
    </FieldWrapper>
  );
};

export default ScholarlyArticleSingleField;
